import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { FMS_READ_SCOPE, fmsReadBasePath } from '#/api/fmsMgmt/fmsReadScope';

/**
 * GET `/fms/payment-requests/payees`（`.read`）或 `/fms/payment-requests/self/payees`（`.self`）。
 * 回請款單曾用過的領款人 `{ id, accountNo, name }`；不受列表其他篩選影響。
 */
export async function fetchPaymentRequestPayeeOptions({
  keyword = '',
  page = 1,
  pageSize = 20,
  scope = FMS_READ_SCOPE.ALL,
} = {}) {
  const params = { page, page_size: pageSize };
  if (keyword) {
    params.keyword = keyword;
  }
  const { data: raw } = await request.get(`${fmsReadBasePath('payment-requests', scope)}/payees`, {
    params,
  });
  return parseVer4ListResponse(raw);
}
